<template>
  <div>
    <b-button
      v-b-toggle.collapse-1
      class="py-1 px-3"
      :style="{
        background: 'linear-gradient(to right, #b3661c , #ed9339)',
        border: 'none',
        color: 'white'
      }"
    >
      Generate Report for Jeem1
    </b-button>

    <b-collapse
      id="collapse-1"
      class="mt-2"
    >
      <b-row
        class="py-1"
        align-h="around"
      >
        <!-- Dynamic buttons from API -->
        <b-button
          v-for="item in dataTable"
          :key="item.id"
          size="sm"
          style="background: blue !important; border: none; margin-bottom: 4px;"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: `jeem-by-request-type/${item.id}` }
            })
          "
        >
          {{ item.name.en }}
        </b-button>

        <!-- Static buttons -->
        <b-button
          size="sm"
          style="background-color: #b3661c !important; border: none"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: 'jeem-IECEE' }
            })
          "
        >
          IECEE
        </b-button>

        <b-button
          size="sm"
          style="background-color: #d57922 !important; border: none"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: 'jeem-quality' }
            })
          "
        >
          Quality
        </b-button>

        <b-button
          size="sm"
          style="background-color: #f78c27 !important; border: none"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: 'jeem-conformity/general' }
            })
          "
        >
          C & E & M & C
        </b-button>

        <b-button
          size="sm"
          style="background-color: #f78c27 !important; border: none"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: 'jeem-conformity/ev' }
            })
          "
        >
          EV
        </b-button>

        <b-button
          size="sm"
          style="background-color: #f78c27 !important; border: none"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: 'jeem-conformity/eva' }
            })
          "
        >
          EV & A
        </b-button>

        <b-button
          size="sm"
          style="background-color: #f78c27 !important; border: none"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: 'jeem-conformity/pc' }
            })
          "
        >
          P & C
        </b-button>

        <b-button
          size="sm"
          style="background-color: #ed9339 !important; border: none"
          @click="
            $router.push({
              name: 'add-auto-generate-report',
              params: { name: 'jeem-all' }
            })
          "
        >
          All
        </b-button>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import axios from 'axios'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import decryptData from '@/store/auth/decryptData'

export default {
  data() {
    return {
      loader: true,
      dataTable: [],
    }
  },

  mounted() {
    this.getAnalysis()
  },
  methods: {
    getAnalysis() {
      axios
        .get('jeem/request-types')
        .then(res => {
          const decrypted = decryptData(res.data.payload)
          this.dataTable = decrypted.message || [] // use .message
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          this.$toasted.show('Error fetching data', {
            component: ToastificationContent,
            props: {
              title: error.response.data.payload.message || 'Error fetching data',
              icon: 'BellIcon',
              variant: 'error',
            },
          })
        })
        .finally(() => {
          this.loader = false
        })
    },

    slugify(text) {
      return text
        .toString()
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '-')
        .replace(/[^\w-]+/g, '')
        .replace(/--+/g, '-')
    },
  },
}
</script>
